<template>
  <div>
    <template v-if="contractType === 'sale'">
      <div class="kpis">
        <CardKPI
          v-for="([title, value], index) in Object.entries(kpis)"
          :key="index"
          :title="title.toUpperCase()"
          :value="value"
          @click="handleClick(title, 'sale')"
          :class="{ selected: keySelected === `sale-${title}` }"
        />
      </div>
    </template>
    <template v-if="contractType === 'rent'">
      <div class="kpis">
        <CardKPI
          v-for="([title, value], index) in Object.entries(kpisByRentStatus)"
          :key="index"
          :title="title.toUpperCase()"
          :value="value"
          @click="handleClick(title, 'rent')"
          :class="{ selected: keySelected === `rent-${title}` }"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import CardKPI from "../reports-kpis/component/AvgTimeAttention/CardKPI.vue";

export default {
  name: "KpisProperties",
  components: {
    CardKPI
  },
  computed: {
    ...mapGetters("properties", ["kpis", "kpisByRentStatus"]),
    ...mapState("properties", ["filterStatus", "contractType"]),
    keySelected() {
      const key = `${this.contractType}-${this.filterStatus}`;
      return key;
    }
  },
  methods: {
    ...mapActions("properties", ["filterByStatus"]),
    handleClick(value, contractType) {
      this.filterByStatus({ value, contractType });
    }
  }
};
</script>
<style scoped>
.kpis {
  display: flex;
  justify-content: space-around;
  gap: 0.75rem;
}

.kpis .card {
  width: 100%;
  cursor: pointer;
}

.selected {
  background-color: #f5f5f5;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
}
</style>
